import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, requiredTier = null, requireAdmin = false }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="container-jcc py-24 text-center text-ink-muted">Loading…</div>
    );
  }
  if (!user) {
    // Preserve the original path (plus any query) so the Login page can send
    // the user back here after they sign in. Avoids dropping them on /dashboard.
    const next = `${location.pathname}${location.search || ""}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  if (requiredTier && user.membership_tier !== requiredTier && user.role !== "admin") {
    return <Navigate to="/dashboard?upgrade=1" replace />;
  }
  return children;
}
